import { Box, Grid } from "@mui/material";
import { createContext, useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { ActionType } from "../../redux/actions/Snackbars";
import { addWebForm, editWebFormById } from "../../redux/actions/WebForms/webForms";
import GeneralProperties from "./GeneralProperties";
import { TrialWebForm1 } from "./TrialWebForm";
import WebFieldDropZone from "./WebFieldDropZone";
import WebFormProperties from "./WebFormProperties";
import { iWebFormField } from "./schema";
export const FieldsContext = createContext<any>("webFormFields");

function WebFormWorkspace({type,editValue}:{type:string,editValue:any}) {
  const navigate = useNavigate();
  const param = useParams();
  const dispatch = useDispatch();
  const [blocks, setBlocks] = useState<any>(editValue?.webformFieldList || []);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const [editFieldIndex, setEditFieldIndex] = useState<null | number>(null);
  const [editFieldVal, setEditFieldVal] = useState<null | number>(null);


  const cancelHandler = () =>{
    // navigate(type==="Ticket" ? '/webFormList' : "/SurveyTemplates")
    navigate(
              type === "Ticket"?
              "/webFormList"
              : type === "Survey"
              ? "/SurveyTemplates"
              : type === "TicketAdditionalField"
              ? "/TicketAdditionalField"
              : "/");
  }
  
  const submitHandler = useCallback((titleVal:string="",description:string="",ticketType:any=0,categoryVal:any=0) =>{
    if(blocks.length==0){ 
         dispatch({
              type: ActionType.SNACKBAR,
              payload: {
                message:"At least one 'From Elements' field must be filled in to proceed.",
                severity: "error",
                open: true,
              },
            });
      return;
    }
    
    // const hasEmptyMandatory = blocks.some((block: any) => {
    //   if (!block.isMandatory) return false;
    //   const element: any = document.getElementsByName(`${block.id}`)?.[0];
    //   if (!element) return false;
    //   // Checkbox case check
    //   if (block.fieldType === "CheckBox") {
    //   const checkboxes = document.querySelectorAll(
    //     `input[name^="checkBox_${block.id}_"]`
    //   );
    //   const isAnyChecked = Array.from(checkboxes).some(
    //     (cb: any) => cb.checked
    //   );
    //   return !isAnyChecked;
    // }
    //   // For input/textarea/dropdown check
    //   return !element.value || element.value.trim() === "";
    // });
    // if (hasEmptyMandatory) {
    //   dispatch({
    //     type: ActionType.SNACKBAR,
    //     payload: {
    //       message: "Please fill all mandatory fields.",
    //       severity: "error",
    //       open: true,
    //     },
    //   });
    //   return;
    // }

    //COMMENTED VALIDATION FUNTION FOR MANDATORY FIELDS IN ADD WEB FORMS- NOT NEEDED
    // const newErrors: Record<string, string> = {};

    // blocks.forEach((block: any) => {
    //   if (!block.isMandatory) return;

    //   // CHECKBOX
    //   if (block.fieldType === "CheckBox") {
    //     const checkboxes = document.querySelectorAll(
    //       `input[name^="checkBox_${block.id}_"]`
    //     );

    //     const isAnyChecked = Array.from(checkboxes).some(
    //       (cb: any) => cb.checked
    //     );

    //     if (!isAnyChecked) {
    //       newErrors[block.id] = "This field is required";
    //     }
    //     return;
    //   }

    //   // OTHER INPUTS
    //   const element: any = document.getElementsByName(`${block.id}`)?.[0];

    //   if (!element || !element.value || element.value.trim() === "") {
    //     newErrors[block.id] = "This field is required";
    //   }
    // });

    // setErrors(newErrors);

    // if (Object.keys(newErrors).length > 0) {
    //   dispatch({
    //     type: ActionType.SNACKBAR,
    //     payload: {
    //       message: "Please fill all mandatory fields.",
    //       severity: "error",
    //       open: true,
    //     },
    //   });

    //   // scroll to first error
    //   const firstErrorId = Object.keys(newErrors)[0];
    //   const el = document.getElementsByName(firstErrorId)?.[0];
    //   el?.scrollIntoView({ behavior: "smooth", block: "center" });

    //   return;
    // }
    //END OF COMMENTED VALIDATION FUNCTION
    
    const fieldsList:iWebFormField[] = blocks.map((i: any,index:number) => {
      return {
        ...i,
        id: i?.oldId || 0,
        webFormId: param.id ? +param.id : 0,
        fieldId: `${i.id}`,
        ranking : index + 1
      }
    });
    const payload = {
      "id": param.id ? +param.id : 0,
      "name": titleVal,
      "description": description,
      "ticketTypeId" : ticketType,
      "categoryId": categoryVal,
      "type" : type,
      "webformFieldList": fieldsList,
      "isActive": true,
    }
    if (param.id) {
      dispatch(editWebFormById(payload, cancelHandler))
    } else {
      dispatch(addWebForm(payload, cancelHandler))
    }
  },[blocks])
  
  
  const generalForm = useMemo(()=><GeneralProperties type={type} initialVal={editValue} submitHandler={submitHandler}/>,[submitHandler,type,editValue])
  return (
    <Box className="white_bg webforms">
      <Grid container spacing={3}>
        <Grid item md={12} xs={12}>
         {(!param?.id || (param?.id && editValue)) && generalForm}
        </Grid>
        <Grid item md={12} xs={12}><hr /></Grid>
      <FieldsContext.Provider value={{ blocks, setBlocks, editFieldIndex, setEditFieldIndex, editFieldVal, setEditFieldVal, errors, setErrors }}>
          <TrialWebForm1 type={type} />
          <Grid item md={7} xs={12} className={`dropableWebWorkspace ${editFieldIndex !== null ? "disabled" : ""}`}>
            <WebFieldDropZone type={type}/>
          </Grid>

          {editFieldIndex !== null && <WebFormProperties />}
        </FieldsContext.Provider>
      </Grid>

    </Box>
  );
}

export default WebFormWorkspace;